import styled from "styled-components";
export const Container = styled.div<{isAllowMobile?: boolean}>`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 20px;
  color: #333333;

  ${({isAllowMobile}) =>
    isAllowMobile &&
    `
    @media (max-width: 768px) {
      .card-container {
        width: calc(50% - 10px) !important;
      }
    }
  `}

  .card-container {
    width: calc(25% - 15px);
    flex-wrap: wrap;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      font-size: 16px;
      width: 100%;
      padding-bottom: 20px;
      font-weight: 700;
      color: #333333;
    }

    .roll-num {
      font-size: 1.5rem;
      font-weight: 600;
      color: #333333;
      .counter {
        font-size: 18px;
        font-weight: 600;
      }
    }
    .percent {
      display: flex;
      font-size: 0.75rem;
      font-weight: 400;
      color: #333333;
    }
  }
`;

export const CountItemCus = styled.div<{isAllowMobile?: boolean}>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;

  ${({isAllowMobile}) =>
    isAllowMobile &&
    `
    @media screen and (min-width: 769px) and (max-width: 860px) {
      flex-direction: column;
      align-items: flex-start;
    }
  `}
`;
